import { forwardRef, memo, useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { BzDropdown, } from "../../components";
import {
    getAppWaveScreenersDetails,
    getNearestBookValue, getPremiumDiscountData, getScreenersGridData, getScreenersGridDataFailure,
    setArrActiveScreenerData, setArrFavouritesScreeners, setObjselectedScreener, setSelectedCategory
} from "../../redux/actions/screeners";
import { EXCHANGE_NAME_API, EXCHANGE_NAME_SCREENERS, LOCATIONS, SCREENERS_TABS } from "../../utils/global_variables";
import { createNewWatchlist, generateUniqueName, getMappedMktSegIdFromApiExchangeName } from "../../utils/global_functions";
import config from '../../config.json';
import { updateEdisIsLoading } from "../../redux/actions/edis";
import { toastConfig } from "../../redux/actions/toast";
const { TenantId } = config;

const arrNearFilters = [
    { filter: 'Near', key: 'Near', id: 0 },
    { filter: 'Next', key: 'Next', id: 1 },
    { filter: 'Far', key: 'Far', id: 2 }
];
const pageNo = 1;
const pageSize = 10;

const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

const ScreenersNav = ({ segment, setSegment, isExpandCollapse, handleBack, trayExpanded, activeFilter, setActiveFilter }) => {

    const arrScreenersGridData = useSelector(state => state.screeners.arrScreenersGridData);
    const objselectedScreener = useSelector(state => state.screeners.objselectedScreener);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const { watchlists, globalWatchlists } = useSelector(state => state?.watchList);

    const [segmentFilters, setSegmentFilters] = useState([]);
    const [showDropDown, setShowDropDown] = useState(false);

    const exchangeAllowed = (segment) => {
        //Vaibhav S: 11-06-2025: bcast logic added as discussed with akshay screener will not appear in case of marketwatch and trading allowed of
        if (objLoginSession?.data?.exchanges?.includes(segment)||objLoginSession?.data?.bcastExchanges?.includes(segment)) {
            return true;
        } else {
            return false;
        }
    };
    const arrExchangeList = useMemo(() => {
        if (segment === "Equity") {
            return [
                (exchangeAllowed(EXCHANGE_NAME_API.NSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSE, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.NSE_EQ_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.BSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSE, Flag: 0, id: 1, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.BSE_EQ_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.MSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.MSE, Flag: 0, id: 1, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.MSE_EQ_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.NSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSE_INDEX, Flag: 1, id: 2, nMktSegId: 1 },
                (exchangeAllowed(EXCHANGE_NAME_API.BSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSE_INDEX, Flag: 1, id: 3, nMktSegId: 8 },
                (exchangeAllowed(EXCHANGE_NAME_API.NSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSE_SECTOR, Flag: 2, id: 4, nMktSegId: 1 },
                (exchangeAllowed(EXCHANGE_NAME_API.BSE_EQ_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSE_SECTOR, Flag: 2, id: 5, nMktSegId: 8 },
            ].filter((each) => { if (each) { return each; } });
        } else if (segment === "Currency") {
            return [
                (exchangeAllowed(EXCHANGE_NAME_API.NSX_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSECDS, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.NSX_DERV_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.BSECDX_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSECDS, Flag: 0, id: 1, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.BSECDX_DERV_API) },
            ].filter((each) => { if (each) { return each; } });
        } else if (segment === "Commodity") {
            return [
                (exchangeAllowed(EXCHANGE_NAME_API.MCX_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.MCX, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.MCX_DERV_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.ICEX_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.ICEX, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.ICEX_DERV_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.NCDEX_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NCDEX, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.NCDEX_DERV_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.NSE_COMM_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSECOMM, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.NSE_COMM_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.BSE_COMM_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSECOMM, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.BSE_COMM_API) },
            ].filter((each) => { if (each) { return each; } });
        }
        else {
            return [
                (exchangeAllowed(EXCHANGE_NAME_API.NSE_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.NSE, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.NSE_DERV_API) },
                (exchangeAllowed(EXCHANGE_NAME_API.BSE_DERV_API)) && { exchangeName: EXCHANGE_NAME_SCREENERS.BSE, Flag: 0, id: 0, nMktSegId: getMappedMktSegIdFromApiExchangeName(EXCHANGE_NAME_API.BSE_DERV_API) }
            ].filter((each) => { if (each) { return each; } });
        }
    }, [segment]);


    const dispatch = useDispatch();
    const location = useLocation();
    const allScreenersDetails = useSelector(state => state.screeners.allScreenersDetails);
    const arrCategoryOptions = useSelector(state => state.screeners.arrCategoryOptions);
    const arrFavouritesScreeners = useSelector(state => state.screeners.arrFavouritesScreeners);
    const selectedTab = useSelector(state => state.screeners.selectedTab);
    const strSeletedCategory = useSelector(state => state.screeners.strSeletedCategory);
    const arrActiveScannerData = useSelector(state => state.screeners.arrActiveScannerData);
    const arrIndexSectorList = useSelector(state => state.screeners.arrIndexSectorList);

    const [arrActiveIndexSectorList, setArrActiveIndexSectorList] = useState([]);
    const [objSelectedIndexSector, setObjSelectedIndexSector] = useState({ Name: 'All' });
    const [objActiveExchange, setObjActiveExchange] = useState(arrExchangeList[0]);
    //Vaibhav Singh:15-04-24:BT-107427: Added Timeout fr api call: Start

    useEffect(() => {
        dispatch(getAppWaveScreenersDetails());
    }, [dispatch]);


    useEffect(() => {
        if (segment !== undefined && objselectedScreener?.GroupId !== 38 && objselectedScreener?.GroupId !== 39) {
            dispatch(getScreenersGridDataFailure([]));
            dispatch(updateEdisIsLoading(true));
        }
        setObjActiveExchange(arrExchangeList[0]);
        const timeoutId = setTimeout(async () => {
            if (segment !== undefined && objselectedScreener?.GroupId !== 38 && objselectedScreener?.GroupId !== 39) {
                if (segment !== "Equity") {
                    await dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: arrExchangeList[0]?.nMktSegId, indexSector: 'All', month: activeFilter?.key }]));
                    dispatch(updateEdisIsLoading(false));
                } else {
                    await dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: arrExchangeList[0]?.nMktSegId, indexSector: 'All', month: "-" }]));
                    dispatch(updateEdisIsLoading(false));
                }
            }
        }, 1000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [arrExchangeList, segment, objselectedScreener?.GroupId]);
    //Vaibhav Singh:15-04-24:BT-107427: Added Timeout fr api call: End
    const checkAllowed = (params) => {
        let isEquityAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSE_EQ_API) || exchangeAllowed(EXCHANGE_NAME_API.BSE_EQ_API) || exchangeAllowed(EXCHANGE_NAME_API.MSE_EQ_API);
        let isDerivativeAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSE_DERV_API) || exchangeAllowed(EXCHANGE_NAME_API.BSE_DERV_API);
        let isCurrencyAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSX_DERV_API) || exchangeAllowed(EXCHANGE_NAME_API.BSECDX_DERV_API);
        let isCommodityallowed = exchangeAllowed(EXCHANGE_NAME_API.MCX_DERV_API) || exchangeAllowed(EXCHANGE_NAME_API.ICEX_DERV_API) || exchangeAllowed(EXCHANGE_NAME_API.NCDEX_DERV_API) || exchangeAllowed(EXCHANGE_NAME_API.NSE_COMM_API) || exchangeAllowed(EXCHANGE_NAME_API.BSE_COMM_API);
        if (!isEquityAllowed && params?.includes("Equity")) {
            params = params?.filter(e => e !== "Equity");
        }
        if (!isDerivativeAllowed && params?.includes("Derivative")) {
            params = params?.filter(e => e !== "Derivative");
        }
        if (!isCurrencyAllowed && params?.includes("Currency")) {
            params = params?.filter(e => e !== "Currency");
        }
        if (!isCommodityallowed && params?.includes("Commodity")) {
            params = params?.filter(e => e !== "Commodity");
        }
        return params;
    };
    useEffect(() => {
        if (objselectedScreener?.GroupId === 16 || objselectedScreener?.GroupId === 24) {
            let filteredData = checkAllowed(["Equity", "Derivative"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 25) {
            let filteredData = checkAllowed(["Derivative", "Currency"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 26) {
            let filteredData = checkAllowed(["Derivative", "Currency", "Commodity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 19 || objselectedScreener?.GroupId === 27 || objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43 || objselectedScreener?.GroupId === 44 || objselectedScreener?.GroupId === 45) {
            let filteredData = checkAllowed(["Derivative", "Currency", "Commodity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 20 || objselectedScreener?.GroupId === 28) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 21 || objselectedScreener?.GroupId === 29) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 22 || objselectedScreener?.GroupId === 30) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 23 || objselectedScreener?.GroupId === 31) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 41 || objselectedScreener?.GroupId === 40 || objselectedScreener?.GroupId === 47) {
            let filteredData = checkAllowed(["Equity", "Derivative", "Currency", "Commodity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 49 || objselectedScreener?.GroupId === 50 || objselectedScreener?.GroupId === 55 || objselectedScreener?.GroupId === 56 || objselectedScreener?.GroupId === 36 || objselectedScreener?.GroupId === 37) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 34 || objselectedScreener?.GroupId === 35) {
            let filteredData = checkAllowed(["Equity"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 38 || objselectedScreener?.GroupId === 39 || objselectedScreener?.GroupId === 46 || objselectedScreener?.GroupId === 32 || objselectedScreener?.GroupId === 33) {
            let filteredData = checkAllowed(["Equity", "Derivative", "Commodity", "Currency"]);
            setSegmentFilters(filteredData?.length ? filteredData : []);
            setSegment(filteredData?.length ? filteredData[0] : "");
        }
        if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 19 || objselectedScreener?.GroupId === 25 || objselectedScreener?.GroupId === 26 || objselectedScreener?.GroupId === 27 || segment === "Derivative" || strSeletedCategory === "Derivative") {
            if (objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43) {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            } else {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Futures' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            }
        } else {
            setArrActiveIndexSectorList([
                { Name: 'All' },]);
            //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
        }
    }, [objselectedScreener, strSeletedCategory]);

    useEffect(() => {
        if (selectedTab === SCREENERS_TABS.MY_FAVOURITES && arrFavouritesScreeners?.length && isExpandCollapse) {
            const filteredArr = arrFavouritesScreeners?.filter((item) => item?.GroupName === objselectedScreener?.GroupName);
            if (filteredArr?.length) {
                // Deepti B: 24/04-24: BT-104814: passing active filter key to month prop
                dispatch(setObjselectedScreener(filteredArr[0]));
                dispatch(getScreenersGridData([{ RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: segment !== "Equity" ? activeFilter?.key : "-" }, { RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            } else {
                dispatch(setObjselectedScreener(arrFavouritesScreeners[0]));
                dispatch(getScreenersGridData([{ RedisKeyPrefix: arrFavouritesScreeners[0].RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: arrFavouritesScreeners[0].RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            }
        }
        if (selectedTab === SCREENERS_TABS.SCANNERS && arrActiveScannerData?.length && isExpandCollapse) {
            // if (!lastScannerData) {
            // Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : Start 
            const categoryCheck = (strSeletedCategory !== "Bullish Strategy" && strSeletedCategory !== "Bearish Strategy") ? strSeletedCategory : "Price";
            const filteredArr = allScreenersDetails?.filter((item) => item?.Category === categoryCheck);
            if (objselectedScreener?.Category !== categoryCheck) {
                dispatch(setObjselectedScreener(filteredArr[0]));
                dispatch(getScreenersGridData([{ RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
                dispatch(setArrActiveScreenerData(filteredArr));
                dispatch(setSelectedCategory(filteredArr[0]?.Category));
            }
            // }
            // else {
            //     dispatch(setObjselectedScreener(lastScannerData))
            //     dispatch(getScreenersGridData([{ RedisKeyPrefix: lastScannerData.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: lastScannerData.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            //     dispatch(setArrActiveScreenerData([lastScannerData]));
            // }
        }
        if (selectedTab === SCREENERS_TABS.STRATERGY && arrActiveScannerData?.length && isExpandCollapse) {
            let filter = (strSeletedCategory === "Bullish Strategy" || strSeletedCategory === "Bearish Strategy") ? strSeletedCategory : "Bullish Strategy";
            const filteredArr = allScreenersDetails?.filter((item) => item?.Category === filter);
            if (objselectedScreener?.Category !== filter) {
                dispatch(setObjselectedScreener(filteredArr[0]));
                // dispatch(getScreenersGridData([{ RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
                dispatch(setArrActiveScreenerData(filteredArr));
                dispatch(setSelectedCategory(filteredArr[0]?.Category));
            }
            // Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : End
        }
    }, [selectedTab]);

    const handleAddToFavourite = () => {
        if (arrFavouritesScreeners.some(obj => obj['GroupId'] === objselectedScreener['GroupId'])) {
            dispatch(setArrFavouritesScreeners(arrFavouritesScreeners?.filter((each) => each.GroupId != objselectedScreener?.GroupId)));
            dispatch(toastConfig({ show: true, autoDismiss: true, message: "Removed from favourites successfully" }));
        } else {
            if (arrFavouritesScreeners?.length < 9) {
                dispatch(setArrFavouritesScreeners([...arrFavouritesScreeners, objselectedScreener]));
                dispatch(toastConfig({ show: true, autoDismiss: true, message: "Added to favourites successfully" }));
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, message: "You can add only 9 Screeners to favourites, Please remove some before adding new one" }));
            }
        }
    };
    // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added :start
    //Vaibhav Singh:15-04-24:BT-107427: Added Timeout fr api call: Start
    const handleScreenrChange = (each) => {
        dispatch(setObjselectedScreener(each));
        if (each?.GroupId === 38 || each?.GroupId === 39) {
            dispatch(getPremiumDiscountData({ statusMode: each.GroupName, pageNo: pageNo, pageSize: pageSize }));
        } else if (each?.GroupId === 48) {
            dispatch(getNearestBookValue({ pageSize: pageSize, jtenantToken: 1 }));
        }
        else {
            if (each?.GroupId === 17 || each?.GroupId === 18 || each?.GroupId === 19 || each?.GroupId === 25 || each?.GroupId === 26 || each?.GroupId === 27 || segment === "Derivative") {
                if (objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43) {
                    setArrActiveIndexSectorList([
                        { Name: 'All' },
                        { Name: 'Options' },
                        { Name: 'Call' },
                        { Name: 'Put', }
                    ]);
                } else {
                    setArrActiveIndexSectorList([
                        { Name: 'All' },
                        { Name: 'Futures' },
                        { Name: 'Options' },
                        { Name: 'Call' },
                        { Name: 'Put', }
                    ]);
                }
                //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: activeFilter?.key }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            }
            else {
                setArrActiveIndexSectorList([
                    { Name: 'All' },]);
                //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            }
            setObjSelectedIndexSector({ Name: 'All' });
        }
    };
    //Vaibhav Singh:15-04-24:BT-107427: Added Timeout fr api call: End
    // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added :end

    const handleScreenerCategoryChange = (each) => {
        if (each === "Value Investment") {
            dispatch(getNearestBookValue({ pageSize: pageSize, jtenantToken: 1 }));
        }
        dispatch(setSelectedCategory(each));
        const filteredArr = allScreenersDetails?.filter((item) => item?.Category === each);
        dispatch(setObjselectedScreener(filteredArr[0]));
        dispatch(getScreenersGridData([{ RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: filteredArr[0].RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
        dispatch(setArrActiveScreenerData(filteredArr));
    };
    const handleIndexSectorChange = (each) => {
        if (each?.Name === "Futures" || each?.Name === "Options" || each?.Name === "Call" || each?.Name === "Put" || each?.Name === "All") {
            let objMap = {
                Futures: "FUT",
                Options: "OPT",
                Call: "CE",
                Put: "PE",
                All: "All"
            };
            setObjSelectedIndexSector(each);
            dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: objActiveExchange.nMktSegId, indexSector: "All", callSector: objMap[each?.Name], month: segment === "Equity" ? "-" : activeFilter?.key }, { RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_2, segmentId: each.nMktSegId, indexSector: each.Name?.split(' ')[0] + '%20' + each.Name?.split(' ')[1] }]));
        } else {
            setObjSelectedIndexSector(each);
            dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: objActiveExchange.nMktSegId, indexSector: each.Name, month: segment === "Equity" ? "-" : activeFilter?.key }, { RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_2, segmentId: each.nMktSegId, indexSector: each.Name?.split(' ')[0] + '%20' + each.Name?.split(' ')[1] }]));
        }
    };
    const handleExchangeChange = (each) => {
        if (each?.exchangeName === EXCHANGE_NAME_SCREENERS.NSE_INDEX || each?.exchangeName === EXCHANGE_NAME_SCREENERS.NSE_SECTOR) {
            setObjActiveExchange(each);
            const arrFilterdIndexSectorList = arrIndexSectorList?.length ? arrIndexSectorList[0]?.filter((item) => each.Flag === item.Flag) : [];
            if (arrFilterdIndexSectorList?.length) {
                dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: each.nMktSegId, indexSector: arrFilterdIndexSectorList[0].Name, month: segment === "Equity" ? "-" : activeFilter?.key }, { RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_2, segmentId: each.nMktSegId, indexSector: arrFilterdIndexSectorList[0].Name?.split(' ')[0] + '%20' + arrFilterdIndexSectorList[0].Name?.split(' ')[1] }]));
                setArrActiveIndexSectorList(arrFilterdIndexSectorList);
                setObjSelectedIndexSector(arrFilterdIndexSectorList[0]);
            }

        } else if (each?.exchangeName === EXCHANGE_NAME_SCREENERS.BSE_INDEX || each?.exchangeName === EXCHANGE_NAME_SCREENERS.BSE_SECTOR) {
            setObjActiveExchange(each);
            const arrFilterdIndexSectorList = arrIndexSectorList?.length ? arrIndexSectorList[1].filter((item) => each.Flag === item.Flag) : [];
            if (arrFilterdIndexSectorList?.length) {
                dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: each.nMktSegId, indexSector: arrFilterdIndexSectorList[0].Name, month: segment === "Equity" ? "-" : activeFilter?.key }, { RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_2, segmentId: each.nMktSegId, indexSector: arrFilterdIndexSectorList[0].Name?.split(' ')[0] + '%20' + arrFilterdIndexSectorList[0].Name?.split(' ')[1] }]));
                setArrActiveIndexSectorList(arrFilterdIndexSectorList);
                setObjSelectedIndexSector(arrFilterdIndexSectorList[0]);
            }
        }
        else {
            if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 19 || objselectedScreener?.GroupId === 25 || objselectedScreener?.GroupId === 26 || objselectedScreener?.GroupId === 27 || segment === "Derivative") {
                if (objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43) {
                    setArrActiveIndexSectorList([
                        { Name: 'All' },
                        { Name: 'Options' },
                        { Name: 'Call' },
                        { Name: 'Put', }
                    ]);
                } else {
                    setArrActiveIndexSectorList([
                        { Name: 'All' },
                        { Name: 'Futures' },
                        { Name: 'Options' },
                        { Name: 'Call' },
                        { Name: 'Put', }
                    ]);
                }
            } else {
                setArrActiveIndexSectorList([
                    { Name: 'All' },]);
                //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
            }
            setObjSelectedIndexSector({ Name: 'All' });
            setObjActiveExchange(each);
            dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: each.nMktSegId, indexSector: 'All', month: segment === "Equity" ? "-" : activeFilter?.key }, { RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_2, segmentId: each.nMktSegId, indexSector: 'All', month: segment !== "Equity" ? "-" : activeFilter?.key }]));
        }

    };

    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    const handleCreateWatchlist = () => {
        const arrScrips = (objselectedScreener?.GroupId === 40 ? arrScreenersGridData?.advance : objselectedScreener?.GroupId === 41 ? arrScreenersGridData?.decline : arrScreenersGridData)?.map((eachScrip) => {
            if (objselectedScreener?.GroupId === 38 || objselectedScreener?.GroupId === 39 || objselectedScreener?.GroupId === 48) {
                if (eachScrip?.ScripData_BSE !== "-" || eachScrip?.ScripData_NSE !== "-") {
                    return { nMarketSegmentId: eachScrip?.MktSegId, nToken: eachScrip?.nToken };
                } else { }
            } else {
                return { nMarketSegmentId: eachScrip?.nMarketSegmentId, nToken: eachScrip?.nToken };
            }
        }).filter((value) => {
            if (value !== undefined) {
                return value;
            } else { }
        });
        let wathlistToSearch = objselectedScreener?.GroupName;
        const suffixName = generateUniqueName(wathlistToSearch, globalWatchlists, watchlists);
        createNewWatchlist(objLoginSession, arrScrips, "static", TenantId, suffixName, "screeners", dispatch);
    };
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end

    const handleMonthChange = (each) => {
        setActiveFilter(each);
        dispatch(getScreenersGridData([{ RedisKeyPrefix: objselectedScreener.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: segment === "Equity" ? "-" : each?.key }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
    };

    // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added :start
    const handleSegmentChange = (each) => {
        setSegment(each);
        if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 19 || objselectedScreener?.GroupId === 25 || objselectedScreener?.GroupId === 26 || objselectedScreener?.GroupId === 27 || each === "Derivative" || each == "Commodity" || each == "Currency" || strSeletedCategory === "Derivative") {
            if (objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43) {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            } else {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Futures' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            }
        } else {
            setArrActiveIndexSectorList([
                { Name: 'All' },]);
            //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
        }
        setObjSelectedIndexSector({ Name: 'All' });
    };

    useEffect(() => {
        if (objselectedScreener?.GroupId === 17 || objselectedScreener?.GroupId === 18 || objselectedScreener?.GroupId === 19 || objselectedScreener?.GroupId === 25 || objselectedScreener?.GroupId === 26 || objselectedScreener?.GroupId === 27 || segment === "Derivative" || segment == "Commodity" || segment == "Currency" || strSeletedCategory === "Derivative") {
            if (objselectedScreener?.GroupId === 42 || objselectedScreener?.GroupId === 43) {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            } else {
                setArrActiveIndexSectorList([
                    { Name: 'All' },
                    { Name: 'Futures' },
                    { Name: 'Options' },
                    { Name: 'Call' },
                    { Name: 'Put', }
                ]);
            }

        } else {
            setArrActiveIndexSectorList([
                { Name: 'All' },]);
            //dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: objActiveExchange?.nMktSegId, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
        }
        setObjSelectedIndexSector({ Name: 'All' });
    }, [segment]);
    // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added 


    const [isWatchlistDisable, setIsWatchlistDisable] = useState(false);

    useEffect(() => {
        if (objselectedScreener?.GroupId === 40 || objselectedScreener?.GroupId === 41) {
            if (arrScreenersGridData?.advance?.length > 0 || arrScreenersGridData?.decline?.length > 0) {
                setIsWatchlistDisable(false);
            } else {
                setIsWatchlistDisable(true);
            }
        } else {
            if (arrScreenersGridData?.length > 0) {
                setIsWatchlistDisable(false);

            } else {
                setIsWatchlistDisable(true);
            }
        }
    }, [arrScreenersGridData, objselectedScreener]);


    return (
        <>{(location?.pathname === LOCATIONS.DASHBOARD) ? <>
            {isExpandCollapse ?
                <>
                    {(arrActiveScannerData?.length) ?
                        <>
                            <Container fluid className='g-0 mb-2'>
                                <Row className='g-0'>
                                    <Col md={7} className='d-flex justify-content-start align-items-center'>
                                        {selectedTab !== SCREENERS_TABS.MY_FAVOURITES &&
                                            <div className='screen-dropdown me-2'>
                                                <BzDropdown>
                                                    {/* Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : Start */}
                                                    <Dropdown.Toggle>{strSeletedCategory === "Market" ? "HOLDINGS" : strSeletedCategory}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {selectedTab === SCREENERS_TABS.STRATERGY && arrCategoryOptions?.map((each) => (each === "Bullish Strategy" || each === "Bearish Strategy") ? <Dropdown.Item onClick={handleScreenerCategoryChange.bind(this, each)}>
                                                            {each?.toUpperCase()}
                                                        </Dropdown.Item> : null)}
                                                        {selectedTab === SCREENERS_TABS.SCANNERS && arrCategoryOptions?.map((each) => (each !== "Bullish Strategy" && each !== "Bearish Strategy") ? <Dropdown.Item onClick={handleScreenerCategoryChange.bind(this, each)}>
                                                            {each === "Market" ? "HOLDINGS" : each?.toUpperCase()}
                                                        </Dropdown.Item> : null)}
                                                    </Dropdown.Menu>
                                                    {/* Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : End */}
                                                </BzDropdown>
                                            </div>
                                        }
                                        <div className='screen-dropdown me-2'>
                                            <BzDropdown>
                                                {/* SumitG - 05-12-23 */}
                                                <Dropdown.Toggle>{objselectedScreener?.GroupName?.toUpperCase()}</Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {/* Vaibhav S: 15-01-24: BT-109095: allScreenerDetails added : Start */}

                                                    {selectedTab !== SCREENERS_TABS.MY_FAVOURITES ? allScreenersDetails?.filter(item => item?.Category === objselectedScreener?.Category && item.GroupId !== 40 && item.GroupId !== 41)?.map((each) => <Dropdown.Item onClick={handleScreenrChange.bind(this, each)}>
                                                        {each?.GroupName?.toUpperCase()}

                                                    </Dropdown.Item>) :
                                                        arrFavouritesScreeners?.map((each) => <Dropdown.Item onClick={handleScreenrChange.bind(this, each)}>
                                                            {each?.GroupName?.toUpperCase()}
                                                        </Dropdown.Item>)
                                                    }
                                                </Dropdown.Menu>
                                                {/* Vaibhav S: 15-01-24: BT-109095: allScreenerDetails added : End */}
                                            </BzDropdown>
                                        </div>
                                        {((objselectedScreener?.GroupId !== 38 && objselectedScreener?.GroupId !== 39 && objselectedScreener?.GroupId !== 48) && strSeletedCategory?.toUpperCase() !== "MARKET") ?
                                            <>
                                                {segmentFilters?.length ?
                                                    <div className='screen-dropdown me-2'>
                                                        <BzDropdown>
                                                            {/* SumitG - 05-12-23 */}
                                                            <Dropdown.Toggle className='btn-default'>{segment?.toUpperCase()}</Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {segmentFilters?.map((each) => <Dropdown.Item key={each} onClick={handleSegmentChange.bind(this, each)}>{each?.toUpperCase()}</Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </BzDropdown>
                                                    </div>
                                                    : null}
                                                {arrExchangeList?.length ?
                                                    <div className='screen-dropdown me-2'>
                                                        <BzDropdown>
                                                            {/* SumitG - 05-12-23 */}
                                                            <Dropdown.Toggle className='btn-default'>{objActiveExchange?.exchangeName?.toUpperCase()}</Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {arrExchangeList?.map((each, index) => <Dropdown.Item key={index} onClick={handleExchangeChange.bind(this, each)}>{each?.exchangeName?.toUpperCase()}</Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </BzDropdown>
                                                    </div>
                                                    : null}
                                                {segment !== "Equity" ?
                                                    <div className='screen-dropdown me-2'>
                                                        <BzDropdown>
                                                            <Dropdown.Toggle className='btn-default'>{activeFilter?.filter?.toUpperCase()}</Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {arrNearFilters?.map((each) => <Dropdown.Item key={each.id} onClick={handleMonthChange.bind(this, each)}>{each?.filter?.toUpperCase()}</Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </BzDropdown>
                                                    </div>
                                                    : null}
                                                <div className='screen-dropdown me-2'>
                                                    <BzDropdown>
                                                        {/* SumitG - 05-12-23 */}
                                                        <Dropdown.Toggle className='btn-default'>{objSelectedIndexSector?.Name?.length > 12 ? `${objSelectedIndexSector?.Name?.slice(0, 11)}...`.toUpperCase() : objSelectedIndexSector?.Name?.toUpperCase()}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {arrActiveIndexSectorList?.map((each) => <Dropdown.Item onClick={handleIndexSectorChange.bind(this, each)}>{each?.Name?.toUpperCase()}</Dropdown.Item>
                                                            )}
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </> : null}
                                    </Col>
                                    <Col md={5} className='d-flex justify-content-end align-items-center'>
                                        <Dropdown className='d-flex align-items-center'>
                                            <Dropdown.Toggle as={CustomDropdownToggle}>
                                                <div className='icon-20 icon-kebab icon-dark'></div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={handleAddToFavourite}>
                                                    <Container className='p-0'>
                                                        <Row className='g-0'>
                                                            <Col>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className={`icon-14 icon-dark me-2 ${arrFavouritesScreeners?.some((each) => each.GroupId === objselectedScreener?.GroupId) ? 'icon-favourites-fill icon-negative' : 'icon-favourites icon-primary'}`}></div>
                                                                    <span className='font-regular font-size3 color-text'>{arrFavouritesScreeners?.some((each) => each.GroupId === objselectedScreener?.GroupId) ? 'Remove From Favourites' : 'Add to Favourites'}</span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                </Dropdown.Item>
                                                {strSeletedCategory !== "Market" ?
                                                    <Dropdown.Item onClick={handleCreateWatchlist} disabled={isWatchlistDisable}>
                                                        <Container className='p-0'>
                                                            <Row className='g-0'>
                                                                <Col>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div class="icon-12 icon-add icon-dark me-2"></div>
                                                                        <span className='font-regular font-size3 color-text'>Create Watchlist</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Dropdown.Item>
                                                    : null}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                </Row>
                            </Container>
                        </>
                        : null
                    }
                </> :
                <>
                    {/* Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : Start */}
                    {
                        selectedTab !== SCREENERS_TABS.MY_FAVOURITES &&
                        <Row className='g-0'>
                            <Col>
                                {

                                    (selectedTab === SCREENERS_TABS.STRATERGY) &&
                                    <div className='d-flex justify-content-center submenu-wrapper horizontal-scroll-wrap py-1'>
                                        {arrCategoryOptions?.map((each, i) =>
                                            (each === "Bullish Strategy" || each === "Bearish Strategy") ? <div key={i} className={`submenuItem ${strSeletedCategory === each ? 'active' : ''}`} onClick={handleScreenerCategoryChange.bind(this, each)}>{each}</div> : null
                                        )}
                                    </div>
                                }
                                {
                                    (selectedTab === SCREENERS_TABS.SCANNERS) &&
                                    <div className='d-flex justify-content-center submenu-wrapper horizontal-scroll-wrap py-1'>
                                        {arrCategoryOptions?.map((each, i) =>
                                            (each !== "Bullish Strategy" && each !== "Bearish Strategy") ? <div key={i} className={`submenuItem ${strSeletedCategory === each ? 'active' : ''}`} onClick={handleScreenerCategoryChange.bind(this, each)}>{each === "Market" ? "Holdings" : each}</div> : null
                                        )}
                                    </div>
                                }
                            </Col>
                        </Row>
                    }
                    {/* Vaibhav S: 15-01-24: BT-109095: Stategy and scanner logic added : End */}
                </>
            }

        </>

            :
            //Watchlist Side tray

            <>
                {isExpandCollapse ?
                    <>
                        {(arrActiveScannerData?.length) ?
                            <>
                                <div className='px-2'>
                                    <Row className='g-0 my-2 justify-content-around align-items-center'>
                                        <Col md={`${trayExpanded ? '7' : '12'}`} className='horizontal-scroll-wrap d-flex justify-content-start align-items-center'>
                                            {selectedTab !== SCREENERS_TABS.MY_FAVOURITES &&
                                                <div className='screen-dropdown me-2 mb-1'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle>{strSeletedCategory === "Market" ? "HOLDINGS" : strSeletedCategory}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {selectedTab === SCREENERS_TABS.STRATERGY && arrCategoryOptions?.map((each) => (each === "Bullish Strategy" || each === "Bearish Strategy") ? <Dropdown.Item onClick={handleScreenerCategoryChange.bind(this, each)}>
                                                                {each?.toUpperCase()}
                                                            </Dropdown.Item> : null)}
                                                            {selectedTab === SCREENERS_TABS.SCANNERS && arrCategoryOptions?.map((each) => (each !== "Bullish Strategy" && each !== "Bearish Strategy") ? <Dropdown.Item onClick={handleScreenerCategoryChange.bind(this, each)}>
                                                                {each === "Market" ? "HOLDINGS" : each?.toUpperCase()}
                                                            </Dropdown.Item> : null)}
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            }
                                            <div className='screen-dropdown me-2 mb-1'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle>{objselectedScreener.GroupName?.toUpperCase()}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {selectedTab !== SCREENERS_TABS.MY_FAVOURITES ? allScreenersDetails?.filter(item => item?.Category === objselectedScreener?.Category && item.GroupId !== 40 && item.GroupId !== 41)?.map((each) => <Dropdown.Item onClick={handleScreenrChange.bind(this, each)}>
                                                            {each?.GroupName?.toUpperCase()}
                                                        </Dropdown.Item>) :
                                                            arrFavouritesScreeners?.map((each) => <Dropdown.Item onClick={handleScreenrChange.bind(this, each)}>
                                                                {each?.GroupName?.toUpperCase()}
                                                            </Dropdown.Item>)
                                                        }
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                            {((objselectedScreener?.GroupId !== 38 && objselectedScreener?.GroupId !== 39 && objselectedScreener?.GroupId !== 48) && strSeletedCategory?.toUpperCase() !== "MARKET") ?
                                                <>
                                                    {segmentFilters?.length ?
                                                        <div className='screen-dropdown me-2 mb-1'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>{segment?.toUpperCase()}</Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {segmentFilters?.map((each) => <Dropdown.Item key={each} onClick={handleSegmentChange.bind(this, each)}>{each?.toUpperCase()}</Dropdown.Item>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                        : null}
                                                    {(arrExchangeList?.length) ?
                                                        <div className='screen-dropdown me-2 mb-1'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>{objActiveExchange?.exchangeName?.toUpperCase()}</Dropdown.Toggle>   {/* Bhagyashri P [20-12-2023] : class changes for Sidetray screeners */}
                                                                <Dropdown.Menu>
                                                                    {arrExchangeList?.map((each, index) => <Dropdown.Item key={index} onClick={handleExchangeChange.bind(this, each)}>{each?.exchangeName?.toUpperCase()}</Dropdown.Item>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                        : null}
                                                    {segment !== "Equity" ?
                                                        <div className='screen-dropdown me-2 mb-1'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>{activeFilter?.filter?.toUpperCase()}</Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {arrNearFilters?.map((each) => <Dropdown.Item key={each.id} onClick={handleMonthChange.bind(this, each)}>{each?.filter?.toUpperCase()}</Dropdown.Item>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                        : null}
                                                    <div className='screen-dropdown me-2 mb-1'>
                                                        <BzDropdown>
                                                            <Dropdown.Toggle className='btn-default'>{objSelectedIndexSector?.Name?.length > 12 ? `${objSelectedIndexSector?.Name?.slice(0, 11)}...`.toUpperCase() : objSelectedIndexSector?.Name?.toUpperCase()}</Dropdown.Toggle>   {/* Bhagyashri P [20-12-2023] : class changes for Sidetray screeners */}
                                                            <Dropdown.Menu>
                                                                {arrActiveIndexSectorList?.map((each) => <Dropdown.Item onClick={handleIndexSectorChange.bind(this, each)}>{each?.Name?.toUpperCase()}</Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </BzDropdown>
                                                    </div>
                                                </>
                                                : null}
                                            <Dropdown className='d-flex align-items-center ms-3'>
                                                <Dropdown.Toggle as={CustomDropdownToggle}>
                                                    <div className='icon-20 icon-kebab icon-dark'></div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={handleAddToFavourite}>
                                                        <Container className='p-0'>
                                                            <Row className='g-0'>
                                                                <Col>
                                                                    <div className='d-flex align-items-center'>
                                                                        <div className={`icon-14 icon-dark me-2 ${arrFavouritesScreeners?.some((each) => each.GroupId === objselectedScreener?.GroupId) ? 'icon-favourites-fill icon-negative' : 'icon-favourites icon-primary'}`}></div>
                                                                        <span className='font-regular font-size3 color-text'>{arrFavouritesScreeners?.some((each) => each.GroupId === objselectedScreener?.GroupId) ? 'Remove From Favourites' : 'Add to Favourites'}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Dropdown.Item>
                                                    {strSeletedCategory !== "Market" ?
                                                        <Dropdown.Item onClick={handleCreateWatchlist} disabled={isWatchlistDisable}>
                                                            <Container className='p-0'>
                                                                <Row className='g-0'>
                                                                    <Col>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div class="icon-12 icon-add icon-dark me-2"></div>
                                                                            <span className='font-regular font-size3 color-text'>Create Watchlist</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Container>
                                                        </Dropdown.Item>
                                                        : null}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                            : null
                        }
                    </> :
                    <>
                        {
                            selectedTab !== SCREENERS_TABS.MY_FAVOURITES &&
                            <Row className='g-0 my-3 px-3 align-items-center'>
                                {/* Vaibhav S: 15-01-24: BT-109095: Startegy logic added  : Start */}
                                <Col>
                                    {
                                        (selectedTab === SCREENERS_TABS.STRATERGY) &&
                                        <div className='d-flex justify-content-start submenu-wrapper horizontal-scroll-wrap py-1'>
                                            {arrCategoryOptions?.map((each, i) =>
                                                (each === "Bullish Strategy" || each === "Bearish Strategy") ? <div key={i} className={`submenuItem ${strSeletedCategory === each ? 'active' : ''}`} onClick={handleScreenerCategoryChange.bind(this, each)}>{each}</div> : null
                                            )}
                                        </div>
                                    }
                                    {
                                        (selectedTab === SCREENERS_TABS.SCANNERS) &&
                                        <div className='d-flex justify-content-start submenu-wrapper horizontal-scroll-wrap py-1'>
                                            {arrCategoryOptions?.map((each, i) =>
                                                (each !== "Bullish Strategy" && each !== "Bearish Strategy") ? <div key={i} className={`submenuItem ${strSeletedCategory === each ? 'active' : ''}`} onClick={handleScreenerCategoryChange.bind(this, each)}>{each === "Market" ? "Holdings" : each}</div> : null
                                            )}
                                        </div>
                                    }
                                </Col>
                            </Row>
                            // Vaibhav S: 15-01-24: BT-109095: Startegy logic added  : End 
                        }
                    </>
                }
            </>
        }
        </>
    );
};
export default memo(ScreenersNav);